import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Text from './common/Text';
import Button from './common/Button';

const Home: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="common-container padding-container custom-background">
      <div className="grid gap-32">
        <div className="padding-x-16 text-center grid gap-16">
          <Text className="display-medium">Welcome to BUILT!</Text>
          <Text className="sub-heading">
            Unlock the Power of Innovation and Collaboration
          </Text>
          <Text className="large-regular">
            BUILT connects the University of Virginia&apos;s brightest
            minds—students, faculty, alumni, and sponsors—to foster
            groundbreaking ideas and drive entrepreneurial success.
          </Text>
          <Text className="large-regular">
            To explore our vibrant community and access exclusive opportunities,
            request an invitation to join BUILT today!
          </Text>
        </div>
        <div className="d-flex justify-content-center">
          <Button
            type="button"
            onClick={() => navigate('/request-invite')}
            className="tertiary-button"
          >
            Request an Invitation
          </Button>
        </div>
        <Text className="small-regular align-center">
          Already have an account?
          <Link to="/signin" className="auth-link">
            Log in
          </Link>
        </Text>
      </div>
    </div>
  );
};

export default Home;
